module.exports = __webpack_public_path__ + "img/ESTP.43fded9e.png";